<h2 mat-dialog-title class="mb-4">Why do we need this information</h2>
<mat-dialog-content>
  <ul>
    <!--        <li>-->
    <!--            <p class="text-size-16 mb-1" *ngIf="journeyType === FelloOfferJourneyType.IO; else LWF">-->
    <!--               To give you an accurate offer, we need your information to be 100% accurate.-->
    <!--            </p>-->
    <!--            <ng-template #LWF>-->
    <!--                <p class="text-size-16 mb-1">-->
    <!--                   To recommend the best agents, we need your information to be 100% accurate.-->
    <!--                </p>-->
    <!--            </ng-template>-->
    <!--        </li>-->
    <li>
      <p class="text-size-16 mb-1">We use your name, email address and phone number to verify the accuracy of your submission.</p>
    </li>
    <li>
      <p class="text-size-16 mb-1">Be rest assured — we keep your information safe.</p>
    </li>
  </ul>
</mat-dialog-content>
<mat-dialog-actions class="mt-3">
  <button class="w-100" mat-dialog-close>Got it</button>
</mat-dialog-actions>
